import { Microphone, MicrophoneSlash, SpeakerHigh, SpeakerSlash } from "@phosphor-icons/react";
import { useMicLevel } from "@/hooks/useMicLevel";

const BARS = [-60, -50, -42, -34, -26, -18];

function status(m, call, dead) {
  if (m.muted) return { text: call ? "Call muted" : "Mic muted", color: "#EF4444" };
  if (dead) return { text: "No signal", color: "#EF4444" };
  if (!m.ready) return { text: "Tap to enable meter", color: "var(--o-muted2)" };
  if (m.silentWarn) return { text: `${call ? "No call audio" : "No voice"} ${Math.floor(m.silentFor)}s`, color: "#F59E0B" };
  if (m.db > -12) return { text: "Too loud", color: "#F59E0B" };
  if (m.voice) return { text: m.db < -38 ? "Faint voice" : "Voice", color: "#10B981" };
  return { text: "Quiet", color: "var(--o-muted2)" };
}

// kind="call" meters the online meeting's audio instead of the mic.
export const MicMeter = ({ stream, kind = "mic", dead = false }) => {
  const m = useMicLevel(stream);
  if (!stream) return null;
  const call = kind === "call";
  const st = status(m, call, dead);
  const Icon = call ? (m.muted ? SpeakerSlash : SpeakerHigh) : m.muted ? MicrophoneSlash : Microphone;
  return (
    <div
      className="flex items-center gap-2 h-8 px-2 border border-[var(--o-border)]"
      title={`${call ? "Call audio" : "Mic input"} ${Math.round(m.db)} dBFS. Speech usually sits between -40 and -15.`}
      data-testid={call ? "call-meter" : "mic-meter"}
    >
      <Icon size={14} style={{ color: st.color }} />
      <div className="flex items-end gap-[2px] h-4" data-testid="mic-meter-bars">
        {BARS.map((th, i) => {
          const on = m.db > th;
          const color = i >= 5 ? "#EF4444" : i >= 4 ? "#F59E0B" : "#10B981";
          return (
            <span
              key={th}
              className="w-[3px] transition-[background-color,opacity] duration-75"
              style={{ height: `${35 + i * 13}%`, background: on ? color : "var(--o-border-strong)", opacity: on ? 1 : 0.5 }}
            />
          );
        })}
      </div>
      <span className="font-mono text-[10px] uppercase tracking-[0.1em] w-[92px] truncate" style={{ color: st.color }} data-testid={call ? "call-meter-status" : "mic-meter-status"}>
        {st.text}
      </span>
    </div>
  );
};
